import { apiClient } from './api';

export type SuggestionSection =
  | 'differential_diagnoses'
  | 'recommended_tests_priority1'
  | 'recommended_tests_priority2'
  | 'warnings'
  | 'treatment_suggestions';

export interface RagCitation {
  content?: string;
  chunk_content?: string;
  norm_source?: string;
  source?: string;
  metadata?: Record<string, unknown>;
  score?: number | null;
}

export interface SuggestionDeepDive {
  key: string;
  section: SuggestionSection;
  item_index: number | null;
  item_title: string;
  content: string;
  rag_citations: RagCitation[];
  generated_at: string;
}

interface SuggestionDeepDiveResponse {
  consultation_id: string;
  deep_dive: SuggestionDeepDive;
}

export const suggestionService = {
  deepen: async ({
    consultationId,
    section,
    itemIndex,
    currentReport,
  }: {
    consultationId: string;
    section: SuggestionSection;
    itemIndex?: number;
    currentReport?: string;
  }) => {
    const response = await apiClient.post<SuggestionDeepDiveResponse>(
      `/consultations/${consultationId}/suggestions/deepen`,
      {
        section,
        item_index: itemIndex,
        current_report: currentReport?.trim() || null,
      }
    );
    return response.data;
  },
};
